(function () {
  var header = document.querySelector('.oddit-header');
  if (!header) return;

  // Mega menu — show/hide on hover/focus
  var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
  var megaPanels = header.querySelectorAll('[data-mega-menu-panel]');
  var megaCloseTimer = null;

  function openMega(label) {
    megaPanels.forEach(function (panel) {
      if (panel.getAttribute('data-mega-menu-label') === label) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
    megaTriggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-mega-menu-label') === label) {
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function closeMega() {
    megaPanels.forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    megaTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  megaTriggers.forEach(function (trigger) {
    var label = trigger.getAttribute('data-mega-menu-label');
    var item = trigger.closest('.oddit-header__nav-item');

    trigger.addEventListener('mouseenter', function () {
      if (megaCloseTimer) {
        cancelAnimationFrame(megaCloseTimer);
        megaCloseTimer = null;
      }
      openMega(label);
    });

    trigger.addEventListener('focus', function () {
      openMega(label);
    });

    trigger.addEventListener('click', function (e) {
      // Toggle on click for keyboard / touch users
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      e.preventDefault();
      if (isOpen) {
        closeMega();
      } else {
        openMega(label);
      }
    });

    if (item) {
      item.addEventListener('mouseleave', function () {
        closeMega();
      });
    }
  });

  megaPanels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () {
      var label = panel.getAttribute('data-mega-menu-label');
      openMega(label);
    });
    panel.addEventListener('mouseleave', function () {
      closeMega();
    });

    // Tab switching within this panel
    var tabs = panel.querySelectorAll('[data-mega-menu-tab]');
    var grids = panel.querySelectorAll('[data-mega-menu-grid]');

    function activateTab(index) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-mega-menu-tab-index') === index);
      });
      grids.forEach(function (grid) {
        grid.classList.toggle('is-active', grid.getAttribute('data-mega-menu-grid-index') === index);
      });
    }

    tabs.forEach(function (tab) {
      var index = tab.getAttribute('data-mega-menu-tab-index');
      tab.addEventListener('mouseenter', function () {
        activateTab(index);
      });
      tab.addEventListener('focus', function () {
        activateTab(index);
      });
    });
  });

  // Close mega menu on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMega();
    }
  });

  // Mobile menu toggle
  var mobileMenu = header.querySelector('[data-mobile-menu]');
  var mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
  var mobileMenuCloseTriggers = header.querySelectorAll('[data-mobile-menu-close]');

  // Announcement bar inside the drawer — clone the live bar into the host so
  // merchant edits in the announcement section flow through. Colors come from
  // the announcement section's <style> block, which targets both the original
  // and `.oddit-header__mobile-menu-announcement .oddit-announcement-bar`,
  // so the clone stays in sync with viewport / homepage overrides via CSS.
  var announcementHost = mobileMenu && mobileMenu.querySelector('[data-mobile-menu-announcement]');
  var sourceAnnouncement = document.querySelector('.oddit-announcement-bar');
  var sourceHasMessages = sourceAnnouncement && sourceAnnouncement.querySelector('[data-announcement-slide]');
  if (announcementHost && sourceAnnouncement && sourceHasMessages && !announcementHost.firstChild) {
    var clonedAnnouncement = sourceAnnouncement.cloneNode(true);
    // Strip duplicate IDs so theme-editor targets the original, not the clone.
    if (clonedAnnouncement.id) clonedAnnouncement.removeAttribute('id');
    var dupIds = clonedAnnouncement.querySelectorAll('[id]');
    for (var n = 0; n < dupIds.length; n++) dupIds[n].removeAttribute('id');
    announcementHost.appendChild(clonedAnnouncement);
  }

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.dispatchEvent(new CustomEvent('mobile-menu:close'));
  }

  // Expose for other drawers (search, cart) to chain-close the mobile menu
  // when they themselves close — avoids leaving the mobile menu visible
  // behind a child drawer the user dismissed.
  window.OdditMobileMenu = {
    open: openMobileMenu,
    close: closeMobileMenu,
    isOpen: function () {
      return !!(mobileMenu && mobileMenu.classList.contains('is-open'));
    }
  };

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }

  mobileMenuCloseTriggers.forEach(function (el) {
    el.addEventListener('click', function () {
      // The X button doubles as a "back" affordance while search mode is
      // active inside the menu — first click exits search, second closes the
      // menu. The overlay click always closes outright.
      var isCloseButton = el.classList.contains('oddit-header__mobile-menu-close');
      var panel = mobileMenu && mobileMenu.querySelector('.oddit-header__mobile-menu-panel');
      var inSearch = !!(panel && panel.classList.contains('is-searching'));
      if (isCloseButton && inSearch) {
        document.dispatchEvent(new CustomEvent('mobile-menu:exit-search'));
        return;
      }
      closeMobileMenu();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // Cart toggle — open cart drawer
  var cartToggles = header.querySelectorAll('[data-cart-toggle]');
  for (var i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', function () {
      if (window.OdditCartDrawer) {
        window.OdditCartDrawer.open();
      }
    });
  }

  // Cart count badge — update on cart:updated event
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });

  // Search toggle — open search drawer (desktop only; on mobile the search
  // experience lives inside this menu drawer, so the drawer stays closed).
  var isDesktopViewport = function () {
    return window.matchMedia('(min-width: 990px)').matches;
  };

  var searchToggles = header.querySelectorAll('[data-search-toggle]');
  for (var i = 0; i < searchToggles.length; i++) {
    searchToggles[i].addEventListener('click', function () {
      if (!isDesktopViewport()) return;
      if (window.OdditSearchDrawer) {
        window.OdditSearchDrawer.open();
      }
    });
  }

  // Desktop search input — open search drawer on focus; input itself stays focused as the search field
  var desktopSearchInput = header.querySelector('.oddit-header__search-input');
  if (desktopSearchInput) {
    desktopSearchInput.addEventListener('focus', function () {
      if (!isDesktopViewport()) return;
      if (window.OdditSearchDrawer) {
        window.OdditSearchDrawer.open();
      }
    });
  }
})();